"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initCollapse = initCollapse;
// this is a temporary solution. will be removed
// after https://gainsight.atlassian.net/browse/GE-248987 is implemented
var HIDDEN_CLASS = 'is-hidden';
var ACTIVE_CLASS = 'is-active';

function escapeAttr(value) {
  return typeof CSS !== 'undefined' && CSS.escape ? CSS.escape(value) : value.replace(/["\\]/g, '\\$&');
}

function deactivateOtherTriggers(active) {
  document.querySelectorAll('.js-collapsable--trigger').forEach(function (trigger) {
    if (trigger !== active) trigger.classList.remove(ACTIVE_CLASS);
  });
}

function collapseAccordionSiblings(content, group) {
  var siblings = document.querySelectorAll(".js-collapsable--content[data-accordion=\"".concat(escapeAttr(group), "\"]"));
  siblings.forEach(function (sibling) {
    if (sibling === content) return;
    sibling.classList.add(HIDDEN_CLASS);
    sibling.classList.remove(ACTIVE_CLASS);
    var siblingId = sibling.dataset.collapse;
    if (!siblingId) return;
    document.querySelectorAll(".js-collapsable--trigger[data-toggle=\"".concat(escapeAttr(siblingId), "\"]")).forEach(function (trigger) {
      return trigger.classList.remove(ACTIVE_CLASS);
    });
  });
}

function initCollapse() {
  document.addEventListener('click', function (event) {
    var _target$classList;

    var target = event.target;
    if (!target || (_target$classList = target.classList) !== null && _target$classList !== void 0 && _target$classList.contains('js-phrase')) return;
    var trigger = target.closest('.js-collapsable--trigger');
    if (!trigger) return;
    var toggleId = trigger.dataset.toggle;
    if (!toggleId) return;
    event.preventDefault();
    var contents = document.querySelectorAll(".js-collapsable--content[data-collapse=\"".concat(escapeAttr(toggleId), "\"]"));
    if (!contents.length) return;
    deactivateOtherTriggers(trigger);
    contents.forEach(function (content) {
      var accordionGroup = content.dataset.accordion;
      if (accordionGroup) collapseAccordionSiblings(content, accordionGroup);
      content.classList.toggle(HIDDEN_CLASS);
    });
    trigger.classList.toggle(ACTIVE_CLASS);
  });
}